import React from 'react';
import { benefits } from '../../data/overview';
import { SectionIntro } from '../SectionIntro';
export function Benefits() {
  return <section className="bg-ivory" data-id="element-48" data-mp="7fkuzspo0fqx">
      <div className="mx-auto max-w-site px-5 py-20 md:px-8 lg:py-28" data-id="element-49" data-mp="c7uil23b53q1">
        <SectionIntro label="Practical Benefits" title="Built for reference throughout the diagnostic process." data-id="element-50" data-mp="c8nra8ltu3at" />
        <ul className="mt-12 grid gap-x-12 gap-y-10 md:grid-cols-2" data-id="element-51" data-mp="gbaflzjah639">
          {benefits.map(b => <li key={b.title} className="border-t-2 border-ink pt-6" data-id="element-52" data-mp="3fqxi8re0ffkm">
              <h3 className="font-display text-[22px] font-bold text-ink" data-id="element-53" data-mp="3knxslehw74hj">{b.title}</h3>
              <p className="mt-2 max-w-[460px] text-[17px] leading-[1.65] text-inkSoft" data-id="element-54" data-mp="3onprt0lebya8">{b.text}</p>
            </li>)}
        </ul>
        <p className="mt-16 border-t border-rule pt-8 font-display text-[22px] font-semibold leading-snug text-ink lg:text-[26px]" data-id="element-55" data-mp="13z22ty6db3jb">
          Clearer references. More structured testing. Better-documented decisions.
        </p>
      </div>
    </section>;
}